import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';
import { IConversationSuggestion } from '@/models/suggestedFaq.model';

export enum ConversationEndpoints {
  ROOT = '/chat-conversations',
}

export const staticConversationEndpoints = {
  GET_CONVERSATIONS: ConversationEndpoints.ROOT,
};

export const getConversationEndpoints = ({ id }: { id: string }) => ({
  GET_CONVERSATION: `${ConversationEndpoints.ROOT}/${id}`,
});

export enum ConversationStatus {
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
}

export enum ConversationMessageRole {
  USER = 'user',
  BOT = 'bot',
}

export interface IConversationMessage {
  messageId: string;
  role: ConversationMessageRole;
  text: string;
  createdAt: string;
}

export interface IConversation {
  conversationId: string;
  channelId: number;
  channelSlug: string;
  startedAt: string;
  endedAt: string;
  state: ConversationStatus;
  suggestionCount: number;
  messageCount: number;
  lastActivityAt: string;
}

export interface IConversationDetails extends IConversation {
  messages: IConversationMessage[];
  summary: string;
  suggestions?: IConversationSuggestion[];
}

// ============== DTO ==============

export interface IGetConversationsDTO extends IPaginationDTO {
  conversationId?: string;
  channelId?: number;
  state?: ConversationStatus;
}

// ============== Response ==============

export interface IGetConversationsResponse extends IPaginationResponse {
  conversations: IConversation[];
}
